import styled from 'styled-components'
import { customTheme } from '../../../styles/theme'

interface IDisplayProps {
  $isOpen: boolean;
}

export const Container = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

export const Emoji = styled.img`
  width: 40px;
  height: 40px;
  margin-right: 16px;
`

export const Title = styled.h2`
  margin-bottom: 15px;


  display: flex;
  align-items: flex-end;

  font-weight: bold;
  font-size: 40px;
  line-height: 100%;
  color: #FFFFFF;
`

export const Points = styled.div`
  margin-bottom: 15px;
  font-weight: bold;
  font-size: 18px;
  line-height: 27px;
  color: #FFFFFF;
`

export const Description = styled.div`
  max-width: 516px;
  margin-bottom: 20px;
  word-wrap: break-word;

  /* font-size: 16px; */
  /* line-height: 24px; */
  /* color: #FFFFFF; */
`

export const Uploader = styled.input`
  display: none;
`

export const UploaderContainer = styled.label<IDisplayProps>`
  width: 251px;
  height: 135px;
  padding: 10px;

  display:  ${({ $isOpen }) => $isOpen ? 'flex' : 'none'} ;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  background: #F4F4F4;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.15);
  border-radius: 16px;
  cursor: pointer;

  @media (max-width: ${customTheme.breakpoints[1]}) {
    width: 100%;
  }
`

export const ImageCam = styled.img`
  width: 60px;
  height: 60px;
`

export const Label = styled.p`
  margin-top: 16px;

  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #606060;
`

export const Form = styled.div<IDisplayProps>`
  margin: 20px 0px;

  display:  ${({ $isOpen }) => $isOpen ? 'flex' : 'none'};
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;

  @media (max-width: ${customTheme.breakpoints[2]}) {
    margin: 20px auto 0;
    align-items: center;
  }
`

export const FileWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center; 

  @media (max-width: ${customTheme.breakpoints[2]}) {
    margin-left: 45px;
    max-width: calc(100% - 90px);
  }
`

export const File = styled.img`
  width: 100%;
  max-height: 250px;
  margin-bottom: 20px;
  object-fit: cover;
`

export const Button = styled.button`
  margin-left: 18px;
  
  background: none;
  border: none;
  cursor: pointer;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`

export const FieldLabel = styled.label`
  margin-bottom: 10px;

  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  color: #FFFFFF;

  @media (max-width: ${customTheme.breakpoints[2]}) {
    margin: 0 auto 10px;
  }
`

export const Input = styled.input`
  width: 268px;
  height: 40px;
  padding: 10px;

  background: #F2F2F2;
  border: 0.5px solid #828282;
  box-sizing: border-box;
  border-radius: 8px;
  font-size: 14px;
  line-height: 21px;
  color: #828282;
`
